/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S42_TitleInputs */

const es_privacy_policy_usage_s42_title = /** @type {(inputs: Privacy_Policy_Usage_S42_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.2 Mejora y Desarrollo`)
};

const en_privacy_policy_usage_s42_title = /** @type {(inputs: Privacy_Policy_Usage_S42_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.2 Improvement and Development`)
};

/**
* | output |
* | --- |
* | "4.2 Improvement and Development" |
*
* @param {Privacy_Policy_Usage_S42_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s42_title = /** @type {((inputs?: Privacy_Policy_Usage_S42_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S42_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s42_title(inputs)
	return en_privacy_policy_usage_s42_title(inputs)
});
export { privacy_policy_usage_s42_title as "privacy_policy.usage.s42_title" }